import { Radio } from "antd";
import { useLessonForm } from "./LessonFormContext";
import LastModified from "../../../LastModified";

const EDUCATION_LEVELS = [
  { value: undefined, label: "Seleccione un grado" },
  { value: "KINDER", label: "Preescolar" },
  { value: "PRIMARIA", label: "Primaria" },
];

const LessonFormHeader: React.FC = () => {
  const { educationLevel, setEducationLevel, currentLessonId } = useLessonForm();

  return (
    <div style={{ display: "flex", alignItems: "center", marginBottom: 24 }}>
      <div style={{ marginRight: 32 }}>
        <h2 style={{ margin: 0 }}>
          {currentLessonId ? "Editar Lección" : "Nueva Lección"}
        </h2>
        {currentLessonId && (
          <LastModified entityType="lessons" entityId={currentLessonId} />
        )}
      </div>
      <Radio.Group
        options={EDUCATION_LEVELS}
        onChange={(e) => setEducationLevel(e.target.value || undefined)}
        value={educationLevel}
        style={{ display: "flex", gap: 24 }}
        optionType="button"
        buttonStyle="solid"
      />
    </div>
  );
};

export default LessonFormHeader;
